import React from 'react'
import STRINGS from 'utils/strings'
import { Container, AutocompleteSearch } from 'components/UIElements'

const ArmManagement = ({
  loading = false,
  disabled = false,
  hasError = false,
  errorText = '',
  checked,
  list,
  onToggleItem,
}) => {
  return (
    <Container className='arm-management-section' centered flex column>
      <div className='title'>{STRINGS.armManagement}</div>
      <div>
        <AutocompleteSearch
          loading={loading}
          disabled={disabled}
          hasError={hasError}
          errorText={errorText}
          checked={checked}
          toggleItem={item => {
            onToggleItem(item)
          }}
          id='participant-search-arm'
          placeholder={checked ? checked?.text : 'Search for an arm...'}
          list={list}
        />
      </div>
    </Container>
  )
}

export default ArmManagement
